var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 24,
    viewBox: "0 0 75 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0516 13.4712C19.1324 13.1287 18.1048 13.5888 17.7588 14.4989C17.6813 14.7033 17.5367 14.9641 17.3301 15.2453C17.0254 15.6696 16.5865 16.1195 16.1166 16.5183C15.6466 16.9171 15.1405 17.2647 14.7274 17.4948C13.5706 18.139 12.3312 18.4457 11.097 18.4457C10.5548 18.4457 10.0125 18.3844 9.48582 18.2719C8.52525 18.0623 7.57506 18.6604 7.35819 19.6114C7.14645 20.5623 7.75064 21.503 8.71117 21.7177C9.49099 21.8915 10.2914 21.9784 11.097 21.9784C12.9251 21.9784 14.7842 21.5234 16.4832 20.5725C17.3353 20.0919 18.239 19.4324 19.0653 18.6298C19.4784 18.231 19.8709 17.7913 20.2169 17.3158C20.5629 16.8404 20.8676 16.324 21.0896 15.7463C21.4356 14.8312 20.9708 13.8138 20.0516 13.4712Z",
    fill: "#7A7AF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0507 13.4712C19.1314 13.1287 18.1038 13.5888 17.7578 14.4989C17.6803 14.7033 17.5357 14.9641 17.3291 15.2453C17.0245 15.6696 16.5855 16.1195 16.1156 16.5183C15.6457 16.9171 15.1396 17.2647 14.7264 17.4948C13.5696 18.139 12.3303 18.4457 11.0961 18.4457C10.5538 18.4457 10.0116 18.3844 9.48484 18.2719C8.52428 18.0623 7.57408 18.6604 7.35722 19.6114C7.14547 20.5623 7.74967 21.503 8.71019 21.7177C9.49001 21.8915 10.2904 21.9784 11.0961 21.9784C12.9241 21.9784 14.7832 21.5234 16.4822 20.5725C17.3343 20.0919 18.2381 19.4324 19.0643 18.6298C19.4774 18.231 19.8699 17.7913 20.2159 17.3158C20.5619 16.8404 20.8666 16.324 21.0886 15.7463C21.4346 14.8312 20.9699 13.8138 20.0507 13.4712Z",
    fill: "#FCA311"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0032 10.3677C21.8948 8.81354 21.4352 7.24913 20.6089 5.8074C19.8808 4.53439 18.9202 3.45563 17.8203 2.60187C16.7152 1.75318 15.4654 1.12435 14.1486 0.746011C13.2035 0.475062 12.2172 1.01185 11.9435 1.94747C11.6698 2.88305 12.212 3.85954 13.1571 4.13049C14.0505 4.38609 14.8922 4.81046 15.6358 5.38304C16.3795 5.95566 17.0199 6.6765 17.5156 7.54053C18.0785 8.52213 18.378 9.56506 18.4555 10.6131C18.5226 11.5845 19.3747 12.3156 20.3559 12.2491C21.3319 12.1827 22.0704 11.3391 22.0032 10.3677Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0032 10.3677C21.8948 8.81354 21.4352 7.24913 20.6089 5.8074C19.8808 4.53439 18.9202 3.45563 17.8203 2.60187C16.7152 1.75318 15.4654 1.12435 14.1486 0.746011C13.2035 0.475062 12.2172 1.01185 11.9435 1.94747C11.6698 2.88305 12.212 3.85954 13.1571 4.13049C14.0505 4.38609 14.8922 4.81046 15.6358 5.38304C16.3795 5.95566 17.0199 6.6765 17.5156 7.54053C18.0785 8.52213 18.378 9.56506 18.4555 10.6131C18.5226 11.5845 19.3747 12.3156 20.3559 12.2491C21.3319 12.1827 22.0704 11.3391 22.0032 10.3677Z",
    fill: "#FCA311"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4273 14.3561C16.1882 12.6178 16.1934 9.79059 14.4376 8.04212C12.6818 6.29366 9.82601 6.29366 8.05988 8.0319C6.29892 9.77013 6.04068 14.5963 6.91861 15.4655C7.79136 16.3346 12.6611 16.0943 14.4273 14.3561Z",
    fill: "#FCA311"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4292 14.3565C16.1902 12.6183 16.1954 9.79108 14.4396 8.04261C12.6838 6.29415 9.82796 6.29414 8.06183 8.03238C6.30087 9.77062 6.04264 14.5968 6.92056 15.466C7.79331 16.3351 12.6631 16.0948 14.4292 14.3565Z",
    fill: "url(#paint0_linear_330_10806)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30992 4.05411C10.2653 3.81892 10.8436 2.86288 10.6061 1.91708C10.3685 0.971268 9.40286 0.398643 8.4475 0.633839C7.50763 0.863876 6.58322 1.22176 5.69501 1.71768C3.92372 2.70951 2.52937 4.13078 1.58434 5.76679C0.639314 7.40279 0.143555 9.25861 0.143555 11.1502C0.143555 11.2167 0.143555 11.2832 0.143555 11.3496V22.0756C0.143555 23.047 0.938828 23.8394 1.92518 23.8394C2.91154 23.8394 3.70681 23.0521 3.70681 22.0756V11.14C3.70681 11.1349 3.70681 11.1247 3.70681 11.1196C3.71197 9.85676 4.04765 8.60932 4.67767 7.51525C5.31285 6.41096 6.24238 5.46004 7.44565 4.78518C8.04984 4.45287 8.67469 4.2126 9.30992 4.05411Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30943 4.05411C10.2648 3.81892 10.8432 2.86288 10.6056 1.91708C10.3681 0.971268 9.40237 0.398643 8.44701 0.633839C7.50714 0.863876 6.58273 1.22176 5.69452 1.71768C3.92323 2.70951 2.52889 4.13078 1.58386 5.76679C0.638826 7.40279 0.143066 9.25861 0.143066 11.1502C0.143066 11.2167 0.143066 11.2832 0.143066 11.3496V22.0756C0.143066 23.047 0.93834 23.8394 1.92469 23.8394C2.91105 23.8394 3.70632 23.0521 3.70632 22.0756V11.14C3.70632 11.1349 3.70632 11.1247 3.70632 11.1196C3.71149 9.85676 4.04716 8.60932 4.67718 7.51526C5.31236 6.41096 6.2419 5.46004 7.44516 4.78518C8.04935 4.45287 8.6742 4.2126 9.30943 4.05411Z",
    fill: "#FCA311"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9062 7.23382C30.9579 7.1009 30.9837 6.95264 30.9837 6.8095V6.78393C30.9837 6.64078 30.9579 6.49253 30.9062 6.35956C30.8546 6.22665 30.772 6.09884 30.6739 5.99661L30.6687 5.9915L30.6635 5.98638C30.5602 5.8841 30.4311 5.79721 30.2969 5.74096C30.1574 5.68475 30.0077 5.65918 29.8631 5.65918H29.1762C28.4946 5.65918 27.8491 5.77675 27.2552 6.01706C26.6613 6.25733 26.1243 6.62033 25.644 7.09579C25.1741 7.57125 24.8126 8.10296 24.5698 8.68577C24.3271 9.26858 24.2032 9.90764 24.1929 10.5825V17.6275C24.1929 17.7707 24.2187 17.919 24.2755 18.0519C24.3323 18.1848 24.4201 18.3075 24.5234 18.4098C24.6266 18.512 24.7506 18.5989 24.8848 18.6551C25.0191 18.7114 25.1689 18.737 25.3135 18.737H25.3496C25.4942 18.737 25.644 18.7114 25.7783 18.6551C25.9125 18.5989 26.0364 18.512 26.1398 18.4098C26.243 18.3075 26.3308 18.1848 26.3876 18.0519C26.4444 17.919 26.4703 17.7707 26.4703 17.6275V10.5927C26.4754 10.2144 26.5425 9.877 26.6716 9.56514C26.8008 9.25324 26.997 8.96695 27.2604 8.70111C27.5289 8.43528 27.8181 8.24099 28.1331 8.11319C28.4481 7.98534 28.7889 7.91891 29.1711 7.91891H29.8579C30.0077 7.91891 30.1574 7.89334 30.2917 7.83708C30.4311 7.78087 30.5551 7.69905 30.6584 7.5917C30.7668 7.49454 30.8494 7.37185 30.9062 7.23382Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5906 7.57636C40.9506 6.94242 40.238 6.46184 39.4526 6.13975C38.6677 5.81767 37.8211 5.65918 36.9171 5.65918C36.0136 5.65918 35.1613 5.81767 34.3816 6.13975C33.5967 6.46184 32.8841 6.94242 32.2437 7.57636C31.6033 8.21031 31.1179 8.91585 30.7926 9.69295C30.4672 10.47 30.3071 11.3085 30.3071 12.2032C30.3071 13.0979 30.4672 13.9414 30.7926 14.7134C31.1179 15.4905 31.6033 16.196 32.2437 16.83C32.8841 17.4639 33.5967 17.9445 34.3816 18.2666C35.1665 18.5887 36.0136 18.7472 36.9171 18.7472C37.8211 18.7472 38.673 18.5887 39.4526 18.2666C40.238 17.9445 40.9506 17.4639 41.5906 16.83C42.2311 16.196 42.7165 15.4905 43.0418 14.7134C43.3671 13.9363 43.5273 13.0979 43.5273 12.2032C43.5273 11.3085 43.3671 10.4649 43.0418 9.69295C42.7113 8.91585 42.2258 8.21031 41.5906 7.57636ZM39.9692 15.2656C39.5459 15.6899 39.0862 16.0018 38.5802 16.2114C38.0741 16.421 37.5265 16.5232 36.9171 16.5232C36.313 16.5232 35.7606 16.4159 35.2545 16.2114C34.7485 16.0018 34.2836 15.6899 33.855 15.2656C33.4313 14.8412 33.1165 14.3811 32.9099 13.8801C32.7033 13.3791 32.5947 12.8371 32.5947 12.2441C32.5947 11.6459 32.698 11.0989 32.9099 10.5978C33.1165 10.0968 33.4313 9.6367 33.855 9.21237C34.2836 8.78801 34.7485 8.47615 35.2545 8.26657C35.7606 8.05694 36.313 7.9547 36.9171 7.9547C37.5265 7.9547 38.0789 8.06205 38.5802 8.26657C39.0862 8.47615 39.5459 8.78801 39.9639 9.21237C40.3925 9.6367 40.7077 10.0968 40.9196 10.603C41.131 11.104 41.2343 11.651 41.2343 12.2492C41.2343 12.8422 41.1262 13.3842 40.9196 13.8852C40.7129 14.376 40.3977 14.8361 39.9692 15.2656Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5805 7.57636C54.9401 6.94241 54.2274 6.46184 53.4425 6.13975C52.6576 5.81767 51.8105 5.65918 50.907 5.65918C50.003 5.65918 49.1512 5.81767 48.3715 6.13464C47.5914 6.45161 46.8788 6.93219 46.2436 7.56102C45.6031 8.19497 45.1181 8.90051 44.7924 9.67249C44.4672 10.4445 44.3021 11.2829 44.2969 12.1776V22.5355C44.2969 22.6787 44.3227 22.8269 44.3796 22.9599C44.4361 23.0928 44.5241 23.2155 44.6274 23.3177C44.7307 23.42 44.8546 23.5069 44.989 23.5632C45.1229 23.6194 45.2726 23.6449 45.4175 23.6449H45.4534C45.5983 23.6449 45.748 23.6194 45.882 23.5632C46.0164 23.5069 46.1403 23.42 46.2436 23.3177C46.3469 23.2155 46.4349 23.0928 46.4918 22.9599C46.5483 22.8269 46.5741 22.6787 46.5741 22.5355V17.101C47.1734 17.556 47.7722 17.9241 48.3816 18.1899C49.2129 18.558 50.0547 18.7421 50.8965 18.7421C51.8005 18.7421 52.6523 18.5836 53.432 18.2615C54.2173 17.9394 54.93 17.4588 55.57 16.8249C56.2104 16.1909 56.6959 15.4854 57.0212 14.7083C57.3464 13.9312 57.5066 13.0928 57.5066 12.198C57.5066 11.3034 57.3464 10.4598 57.0212 9.68783C56.7064 8.91585 56.2209 8.21031 55.5805 7.57636ZM53.959 15.2042C53.5353 15.6286 53.0757 15.9404 52.5749 16.15C52.0688 16.3596 51.5216 16.4619 50.9123 16.4619C50.3077 16.4619 49.7553 16.3545 49.2492 16.15C48.7432 15.9404 48.2783 15.6286 47.8497 15.2042C47.4264 14.7799 47.1112 14.3197 46.9046 13.8187C46.698 13.3177 46.5898 12.7758 46.5898 12.1827C46.5898 11.5846 46.6932 11.0375 46.9046 10.5365C47.1112 10.0355 47.4264 9.57537 47.8497 9.151C48.2783 8.7318 48.7432 8.41994 49.2492 8.21542C49.7553 8.01091 50.3077 7.90356 50.9123 7.90356C51.5164 7.90356 52.0688 8.0058 52.5696 8.21542C53.0757 8.41994 53.5353 8.7318 53.9643 9.151C54.3929 9.57537 54.7076 10.0355 54.9195 10.5416C55.1314 11.0426 55.2347 11.5897 55.2347 12.1878C55.2347 12.7809 55.1261 13.3228 54.9195 13.8238C54.7076 14.3197 54.3929 14.7748 53.959 15.2042Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2902 13.6564C71.2538 13.549 71.2022 13.4519 71.1405 13.3599L71.1352 13.3548L71.13 13.3496C71.0214 13.2065 70.8874 13.0838 70.7272 13.002C70.567 12.9202 70.3862 12.8844 70.2059 12.8844C70.0868 12.8844 69.9682 12.8997 69.8543 12.9304C69.6841 12.9764 69.5238 13.0685 69.3947 13.1911C69.266 13.3138 69.178 13.4723 69.1158 13.641C68.9661 14.0705 68.7648 14.4488 68.5117 14.7914C68.2587 15.1339 67.9488 15.4355 67.5824 15.7014C67.2002 15.9774 66.7975 16.1819 66.3737 16.32C65.9504 16.458 65.5061 16.5245 65.0364 16.5245C64.329 16.5245 63.6833 16.3609 63.0739 16.0337C62.5832 15.7679 62.1187 15.3946 61.6744 14.9038C62.6559 14.4693 64.1171 13.82 66.0537 12.9508C67.8871 12.1328 69.3641 11.4733 70.4895 10.9723H70.4948H70.5C70.6292 10.911 70.7531 10.8291 70.8511 10.7218C70.9492 10.6196 71.0267 10.4918 71.0783 10.3588V10.3537C71.1247 10.231 71.1505 10.0981 71.1505 9.96516C71.1505 9.80667 71.1094 9.64307 71.0424 9.49992V9.49481C70.7789 8.9273 70.4484 8.41097 70.0509 7.95081C69.653 7.49069 69.1833 7.08682 68.6514 6.73916C68.109 6.38639 67.5307 6.12056 66.9266 5.94162C66.3221 5.76267 65.6922 5.67578 65.0364 5.67578C64.1324 5.67578 63.2806 5.83422 62.5009 6.15631C61.716 6.4784 61.0033 6.95902 60.3629 7.59297C59.7225 8.22691 59.237 8.93241 58.9117 9.70951C58.5865 10.4866 58.4263 11.3251 58.4263 12.2198C58.4263 13.1144 58.5865 13.958 58.9117 14.73C59.237 15.5071 59.7225 16.2126 60.3629 16.8466C61.0033 17.4805 61.716 17.9611 62.5009 18.2832C63.2858 18.6053 64.1324 18.7638 65.0364 18.7638C65.7386 18.7638 66.4201 18.6615 67.0658 18.457C67.7115 18.2525 68.3257 17.9458 68.9044 17.5368C69.4674 17.138 69.9476 16.6727 70.3398 16.1461C70.7325 15.6247 71.0472 15.0367 71.2696 14.3977V14.3926C71.316 14.2699 71.3418 14.137 71.3418 14.004C71.3418 13.8711 71.3261 13.7586 71.2902 13.6564ZM60.7398 12.6645C60.7192 12.4805 60.714 12.3373 60.714 12.2402C60.714 11.642 60.8173 11.095 61.0292 10.594C61.2354 10.093 61.5505 9.63284 61.9738 9.20852C62.4028 8.78415 62.8673 8.47229 63.3734 8.26267C63.8794 8.05308 64.4323 7.95081 65.0364 7.95081C65.7075 7.95081 66.3326 8.10418 66.9314 8.41604C67.4068 8.66146 67.8612 9.00912 68.3051 9.46413L60.7604 12.8435C60.7503 12.777 60.7451 12.7208 60.7398 12.6645Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9257 1.45243C74.8688 1.3144 74.786 1.19167 74.6779 1.08943L74.6726 1.08432L74.6674 1.07921C74.5641 0.982086 74.4402 0.900265 74.3058 0.849126C74.1714 0.798031 74.027 0.772461 73.8825 0.772461H73.8462C73.7017 0.772461 73.5573 0.798031 73.4229 0.849126C73.2885 0.900265 73.1646 0.982086 73.0613 1.07921L73.056 1.08432L73.0512 1.08943C72.9479 1.19167 72.8599 1.31952 72.803 1.45243C72.7465 1.59046 72.7207 1.73872 72.7207 1.88187V17.6335C72.7207 17.7766 72.7465 17.9249 72.803 18.0578C72.8599 18.1908 72.9479 18.3134 73.0512 18.4157C73.1541 18.518 73.2784 18.6048 73.4124 18.6611C73.5467 18.7173 73.6965 18.7429 73.8409 18.7429H73.8772C74.0217 18.7429 74.1714 18.7173 74.3058 18.6611C74.4402 18.6048 74.5641 18.518 74.6674 18.4157C74.7707 18.3134 74.8583 18.1908 74.9152 18.0578C74.9721 17.9249 74.9979 17.7766 74.9979 17.6335V1.88187C75.0084 1.73872 74.9826 1.59046 74.9257 1.45243Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_330_10806",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 10,
    height: 10
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4292 14.3565C16.1902 12.6183 16.1954 9.79108 14.4396 8.04261C12.6838 6.29415 9.82796 6.29414 8.06183 8.03238C6.30087 9.77062 6.04264 14.5968 6.92056 15.466C7.79331 16.3351 12.6631 16.0948 14.4292 14.3565Z",
    fill: "url(#paint1_linear_330_10806)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_330_10806)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint2_linear_330_10806)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint3_radial_330_10806)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint4_radial_330_10806)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint5_radial_330_10806)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint6_radial_330_10806)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint7_radial_330_10806)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint8_linear_330_10806)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint9_radial_330_10806)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint10_radial_330_10806)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint11_radial_330_10806)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.41222,
    cy: 9.41077,
    rx: 8.44786,
    ry: 8.61341,
    fill: "url(#paint12_radial_330_10806)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_330_10806",
    x1: 6.43586,
    y1: 11.3421,
    x2: 15.7547,
    y2: 11.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128742,
    stopColor: "#7284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2559,
    stopColor: "#7282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#747BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4059,
    stopColor: "#7670FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#795FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#7C49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#7E40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#7C3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7904,
    stopColor: "#7735FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8746,
    stopColor: "#6E27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9483,
    stopColor: "#6213FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_330_10806",
    x1: 6.43586,
    y1: 11.3421,
    x2: 15.7547,
    y2: 11.3421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0128742,
    stopColor: "#7284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2559,
    stopColor: "#7282FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3435,
    stopColor: "#747BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4059,
    stopColor: "#7670FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4563,
    stopColor: "#795FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#7C49FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#7E40FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6877,
    stopColor: "#7C3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7904,
    stopColor: "#7735FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8746,
    stopColor: "#6E27FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9483,
    stopColor: "#6213FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5600FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_330_10806",
    x1: 9.41222,
    y1: 2.77127,
    x2: 13.4238,
    y2: 15.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7481 16.9475) rotate(-130.306) scale(8.7064 8.32063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6361 0.797364) rotate(116.123) scale(9.59335 9.08813)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.14761 0.0795792) rotate(37.1408) scale(15.4547 12.5998)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.37233 2.23293) rotate(45.5559) scale(6.2837 4.56298)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6762 9.41077) rotate(50.446) scale(4.824 3.96646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_330_10806",
    x1: 9.41222,
    y1: 2.77127,
    x2: 13.4238,
    y2: 15.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA1DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7481 16.9475) rotate(-130.306) scale(8.7064 8.32063)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606EF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909ADD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6361 0.797365) rotate(115.751) scale(11.1841 10.5929)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8874FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8874FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.14761 0.0795787) rotate(40.2421) scale(15.8089 12.8624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_330_10806",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.37233 2.23293) rotate(44.0668) scale(9.0014 6.54306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropelLogo);
export default __webpack_public_path__ + "static/media/propelLogo.e30476e3ef05f4007f58e42c39099662.svg";
export { ForwardRef as ReactComponent };